<template>
  <div class="d-flex flex-column justify-content-center h-100">
    <FormWizard
        class="card strong-shadow bg-white"
        :back-button-text="$t('auto_atendimento.cadastro.steps.anterior')"
        :next-button-text="$t('auto_atendimento.cadastro.steps.proximo')"
        :finish-button-text="$t('auto_atendimento.cadastro.steps.enviar')"
        color="#f9b112"
        error-color="#e74a3b"
        @on-complete="onSubmit"
    >
      <template #title>
        <div class="d-flex jusfity-content-between align-items-center">
          <img src="@/assets/img/auto_atendimento/veusinho.png" alt="" class="logo">
          <h2 class="flex-fill">{{ $t('auto_atendimento.cadastro.title') }}</h2>
          <router-link :to="{name: 'vaa.index'}" class="btn btn-outline-warning">
            <b-icon icon="arrow-left"/>
          </router-link>
        </div>
      </template>

      <TabContent :title="$t('auto_atendimento.cadastro.steps.verificacao')" :before-change="validateFirstTab">

        <b-select
            v-model="model.unidade"
            :class="{'mb-3': true, 'border-left-success': model.unidade}"
            :options="unidades | idNomeToValueText"
            :disabled="this.$route.params.unidadeID ? '' : disabled"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              {{ $t('auto_atendimento.cadastro.unidade') }}
            </b-form-select-option>
          </template>
        </b-select>

        <FormGroupFloatLabel
            v-model="model.documento"
            :label="$t('auto_atendimento.cadastro.documento')"
            input-name="documento"
            :validation-values="['', 0]"
            mandatory
            validation-icon
        />
      </TabContent>
      <TabContent :title="$t('auto_atendimento.cadastro.steps.dados')" :before-change="validateSecondTab">
        <b-tabs class="mt-3" card justified>
          <b-tab :title="$t('auto_atendimento.cadastro.steps.dadospessoais')" active>

            <FormGroupFloatLabel
                v-model="model.nome"
                :label="$t('auto_atendimento.cadastro.nome')"
                input-name="name"
                :validation-values="['', 0]"
                mandatory
                validation-icon
            />
            <FormGroupFloatLabel
                v-model="model.email"
                :label="$t('auto_atendimento.cadastro.email')"
                input-name="email"
                :validation-values="['', 0]"
                mandatory
                validation-icon
            />
            <FormGroupFloatLabel
                v-model="model.telefone"
                :label="$t('auto_atendimento.cadastro.telefone')"
                input-name="telefone"
                :validation-values="['', 0]"
                mandatory
                validation-icon
            />
            <b-select
                v-model="model.sexo"
                :class="{'mb-3': true, 'border-left-success': model.sexo}"
                :options="[
                    {text: $t('auto_atendimento.cadastro.masculino'), value: 'masculino'},
                    {text: $t('auto_atendimento.cadastro.feminino'), value: 'feminino'}
                ]"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>{{
                    $t('auto_atendimento.cadastro.sexo')
                  }}
                </b-form-select-option>
              </template>
            </b-select>
            <FormGroupFloatLabel
                v-model="model.dt_nascimento"
                :label="$t('auto_atendimento.cadastro.nascimento')"
                input-name="nascimento"
                input-type="date"
                :validation-values="['', 0]"
                mandatory
                validation-icon
            />

          </b-tab>
          <b-tab :title="$t('auto_atendimento.cadastro.steps.endereco')">

            <FormGroupFloatLabel
                v-model="model.cep"
                :label="$t('auto_atendimento.cadastro.cep')"
                input-name="CEP"
                :validation-values="['', 0]"
                mandatory
                validation-icon
                @blur="procuraCep"
            />
            <!--<b-overlay v-if="model.cep" :show="isLoadingCEP">-->
            <b-select v-model="model.estado" :class="{'mb-3': true, 'border-left-success': model.estado}"
                      :options="states">
              <template #first>
                <b-form-select-option :value="null" disabled>{{
                    $t('auto_atendimento.cadastro.estado')
                  }}
                </b-form-select-option>
              </template>
            </b-select>
            <FormGroupFloatLabel
                v-model="model.cidade"
                :label="$t('auto_atendimento.cadastro.cidade')"
                input-name="cidade"
                :validation-values="['', 0]"
                mandatory
                validation-icon
            />
            <FormGroupFloatLabel
                v-model="model.bairro"
                :label="$t('auto_atendimento.cadastro.bairro')"
                input-name="bairro"
                :validation-values="['', 0]"
                validation-icon
            />
            <FormGroupFloatLabel
                v-model="model.logradouro"
                :label="$t('auto_atendimento.cadastro.logradouro')"
                input-name="logradouro"
                :validation-values="['', 0]"
                mandatory
                validation-icon
            />
            <FormGroupFloatLabel
                v-model="model.numero"
                :label="$t('auto_atendimento.cadastro.numero')"
                input-name="numero"
                :validation-values="['', 0]"
                validation-icon
            />
            <FormGroupFloatLabel
                v-model="model.complemento"
                :label="$t('auto_atendimento.cadastro.complemento')"
                input-name="complemento"
                :validation-values="['', 0]"
                validation-icon
            />

          </b-tab>
        </b-tabs>
      </TabContent>
      <TabContent :title="$t('auto_atendimento.cadastro.steps.documentos')">
        <b-overlay :show="sending">
          <b-form-group :label="$t('auto_atendimento.cadastro.identidade')" class="mt-5">
            <b-form-file
                placeholder="Escolha arquivo ou Solte aqui"
                drop-placeholder="Solte aqui"
                @change="evt => model.identidade = evt.target.files[0]"
            />
          </b-form-group>
          <b-form-group :label="$t('auto_atendimento.cadastro.documentos')" class="mt-5">
            <b-form-file
                placeholder="Escolha arquivo ou Solte aqui"
                drop-placeholder="Solte aqui"
                @change="evt => model.documentos = evt.target.files"
                multiple
            />
          </b-form-group>
        </b-overlay>
      </TabContent>
    </FormWizard>
  </div>
</template>

<script>
import {FormWizard, TabContent} from "vue-form-wizard"
import FormGroupFloatLabel from "@/components/FormGroupFloatLabel";
import "vue-snotify/styles/dark.scss"
import {ACTUAL_LANGUAGE, VS_URL} from "@/providers/EnvironmentProvider";
import {axiosNative} from "@/providers/AxiosServiceProvider";
import Vue from "vue";

Vue.filter('idNomeToValueText', function (value) {
  if (value && Array.isArray(value)) {
    return value.map(ent => {
      return {
        text: ent.nome,
        value: ent.id
      }
    })
  }
  return []
});

export default {
  name: "Form",
  components: {FormGroupFloatLabel, FormWizard, TabContent},
  data() {
    return {
      model: {
        unidade: null,
        documento: null,
        nome: null,
        email: null,
        telefone: null,
        sexo: null,
        dt_nascimento: null,

        cep: null,
        estado: null,
        cidade: null,
        bairro: null,
        logradouro: null,
        numero: null,
        complemento: null,

        identidade: null,
        documentos: [],
      },
      isLoadingCEP: false,
      sending: false,
      unidades: [],
      states: [
        {value: 'AC', text: 'Acre'},
        {value: 'AL', text: 'Alagoas'},
        {value: 'AP', text: 'Amapá'},
        {value: 'AM', text: 'Amazonas'},
        {value: 'BA', text: 'Bahia'},
        {value: 'CE', text: 'Ceará'},
        {value: 'DF', text: 'Distrito Federal'},
        {value: 'ES', text: 'Espírito Santo'},
        {value: 'GO', text: 'Goiás'},
        {value: 'MA', text: 'Maranhão'},
        {value: 'MT', text: 'Mato Grosso'},
        {value: 'MS', text: 'Mato Grosso do Sul'},
        {value: 'MG', text: 'Minas Gerais'},
        {value: 'PA', text: 'Pará'},
        {value: 'PB', text: 'Paraíba'},
        {value: 'PR', text: 'Paraná'},
        {value: 'PE', text: 'Pernambuco'},
        {value: 'PI', text: 'Piauí'},
        {value: 'RJ', text: 'Rio de Janeiro'},
        {value: 'RN', text: 'Rio Grande do Norte'},
        {value: 'RS', text: 'Rio Grande do Sul'},
        {value: 'RO', text: 'Rondônia'},
        {value: 'RR', text: 'Roraima'},
        {value: 'SC', text: 'Santa Catarina'},
        {value: 'SP', text: 'São Paulo'},
        {value: 'SE', text: 'Sergipe'},
        {value: 'TO', text: 'Tocantins'},
      ]
    }
  },
  methods: {
    validate(fieldsToValidate) {
      return new Promise((resolve, reject) => {
        const errorFields = Object.keys(fieldsToValidate).filter(field => !this.model[field])

        if (errorFields.length > 0) {
          errorFields.map(field => this.$snotify.error(
              this.$t('auto_atendimento.cadastro.obrigatorio').replace("%s", fieldsToValidate[field]),
              {
                timeout: 5000,
                position: 'rightBottom'
              }
          ))
          reject(this.$t('auto_atendimento.cadastro.campos_invalidos'))
        }

        resolve(true)
      })
    },
    validateFirstTab() {
      if (ACTUAL_LANGUAGE=== 'pt_BR') {
        let Soma, Resto, strCPF = this.model.documento.replace(/[^0-9]/g,'');
        Soma = 0;
        if (strCPF === "00000000000") {
          this.$snotify.error(this.$t('auto_atendimento.cadastro.documento_invalido'), {timeout: 5000, position: 'rightBottom'})
          return false
        }

        for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;

        if ((Resto === 10) || (Resto === 11))  Resto = 0;
        if (Resto !== parseInt(strCPF.substring(9, 10)) ) {
          this.$snotify.error(this.$t('auto_atendimento.cadastro.documento_invalido'), {timeout: 5000, position: 'rightBottom'})
          return false;
        }

        Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;

        if ((Resto === 10) || (Resto === 11))  Resto = 0;
        if (Resto !== parseInt(strCPF.substring(10, 11) ) ) {
          this.$snotify.error(this.$t('auto_atendimento.cadastro.documento_invalido'), {timeout: 5000, position: 'rightBottom'})
          return false;
        }
      }

      return this.validate({
        documento: this.$t('auto_atendimento.cadastro.documento'),
        unidade: this.$t('auto_atendimento.cadastro.unidade')
      })
    },
    validateSecondTab() {
      return this.validate({
        // complemento: this.$t('auto_atendimento.cadastro.complemento'),
        // numero: this.$t('auto_atendimento.cadastro.numero'),
        logradouro: this.$t('auto_atendimento.cadastro.logradouro'),
        // bairro: this.$t('auto_atendimento.cadastro.bairro'),
        cidade: this.$t('auto_atendimento.cadastro.cidade'),
        estado: this.$t('auto_atendimento.cadastro.estado'),
        cep: this.$t('auto_atendimento.cadastro.cep'),

        dt_nascimento: this.$t('auto_atendimento.cadastro.nascimento'),
        sexo: this.$t('auto_atendimento.cadastro.sexo'),
        telefone: this.$t('auto_atendimento.cadastro.telefone'),
        email: this.$t('auto_atendimento.cadastro.email'),
        nome: this.$t('auto_atendimento.cadastro.nome')
      })
    },
    validateCPF() {

    },
    procuraCep() {
      this.isLoadingCEP = true

      // Nova variável "cep" somente com dígitos.
      const cep = this.model.cep.replace(/\D/g, '')

      // Verifica se campo cep possui valor informado.
      if (cep.length > 7) {
        // Expressão regular para validar o CEP.
        const validacep = /^[0-9]{8}$/

        // Valida o formato do CEP.
        if (validacep.test(cep)) {
          // Consulta o webservice viacep.com.br/
          axiosNative.get(`${VS_URL}/vaa/api/v1/listar/cep/${cep}`)
              .then(dados => {
                if (!dados.erro) {
                  const end = dados.data
                  // Atualiza os campos com os valores da consulta.
                  this.model.logradouro = end.logradouro
                  this.model.bairro = end.bairro
                  this.model.estado = end.uf
                  this.model.cidade = end.localidade
                  this.model.complemento = end.complemento
                  this.model.bairro = end.bairro
                }
              })
        }
      }

      setTimeout(() => {
        this.isLoadingCEP = false
      }, 2000)
    },
    onSubmit() {
      this.sending = true
      let formData = new FormData();
      for (const field in this.model) {
        if (field === 'identidade') {
          formData.append('arquivos[]', this.model.identidade)
          continue;
        }
        if (field === 'documentos') {
          for (let i = 0; i < this.model.documentos.length; i++) {
            formData.append('arquivos[]', this.model.documentos[i])
          }
          continue;
        }

        formData.append(field, this.model[field])
      }

      axiosNative.post(`${VS_URL}/vaa/api/v1/cadastrar/atendimento`, formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(response => {
        this.$snotify.success(this.$t('auto_atendimento.cadastro.mensagem.sucesso'), {position: 'rightBottom'})
        this.sending = false
        this.$router.push({name: 'vaa.qr', params: {id: response.data.id}})
      }).catch(() => {
        this.$snotify.error(this.$t('auto_atendimento.cadastro.mensagem.erro'), {position: 'rightBottom'})
        this.sending = false
      })
    }
  },
  mounted() {
    axiosNative.get(`${VS_URL}/vaa/api/v1/listar/unidade-atendimento`)
        .then(response => {
          this.unidades = response.data
          if (this.$route.params.unidadeID)
          {
            this.model.unidade = this.$route.params.unidadeID
          }
          
        })
   
  }
}
</script>

<style lang="scss" scoped>
.label-float {
  margin-top: 20px;
  margin-bottom: 40px;
}

@keyframes slideInFromLeft {
  0% {
    transform: translateX(200%) scale(2) translateY(25%);
  }
  100% {
    transform: translateX(0);
  }
}

::v-deep.logo {
  width: 50px;
  animation: 1s ease-out 0s 1 slideInFromLeft;
}
</style>
